<div class="from-blueberry to-cotton-candy relative flex h-16 items-center bg-gradient-to-r px-4">
  @if (profileSrv.isLoggedIn()) {
    <div class="flex h-full w-full justify-center">
      <app-nav-bar />
    </div>
    <a
      class="absolute top-1/2 right-4 flex -translate-y-1/2 cursor-pointer items-center gap-2 border-0 bg-transparent px-4 py-2 text-white transition-all hover:shadow hover:brightness-105"
      routerLink="/login"
      (click)="logout()"
    >
      <p class="hidden text-xs font-medium sm:block sm:text-base">Logout</p>
      <span class="material-symbols-outlined text-white">logout</span>
    </a>
  } @else {
    <a
      class="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer border-0 bg-transparent px-4 py-2 text-white transition-all hover:shadow hover:brightness-105"
      routerLink="/login"
    >
      Login
    </a>
  }
</div>
